import $http from './axios'

const query = async function (url, data) {
  return new Promise(resolve => {

    // url = '/api' + url
    $http.get(url, {
      params: data
    }).then(
      res => {
        //console.log('connection query response:', res.data)
        if (res.status === 200) {
          resolve({
            error: res.data.code !== 0,
            data: res.data
          })
        } else {
          resolve({
            error: true,
            data: undefined
          })
        }
      },
      err => {
        console.info('调用失败')
        resolve({
          error: true,
          data: err
        })
      }
    )
  })
}
const update = async function (url, data) {
  // data.token = token()
  return new Promise(resolve => {

    // url = '/api' + url
    $http.post(url, data).then(
      res => {
        //console.log('connection update response:', res.data)
        if (res.status === 200) {
          resolve({
            error: res.data.code !== 0,
            data: res.data
          })
        } else {
          resolve({
            error: true,
            data: res
          })
        }
      },
      err => {
        console.info('调用失败')
        resolve({
          error: true,
          data: err
        })
      }
    )
  })
}
export default {
  query: query,
  update: update
}
